import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { Location } from '@angular/common'

@Component({
    selector: "app-transactiongroup",
    templateUrl: "./transactiongroup.component.html",
    styleUrls: ["./transactiongroup.component.css"],
})
export class TransactiongroupComponent implements OnInit {
    // firstRecordNo = 0;
    loader:boolean=false;
    rowsNo = 10;
    offset:number = 0;
    pageSize:number = 10;
    noOfRecords: number=0;
    sortField: String="dateTimeReceived";
    sortOrder: number = -1;
    searchData: any=[];
    tableHeaders: { field: string; header: string }[];
    group: any;
    headers: HttpHeaders;
    constructor(
        public activatedRoute: ActivatedRoute,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        private location: Location
    ) {}

    ngOnInit() {
        this.group = this.activatedRoute.snapshot.paramMap.get("isback");
        this.tableHeaders = [
            { field: "dateTimeReceived", header: "Date Time" },
            { field: "fileId", header: "Instance Id" },
            { field: "primaryKeyValue", header: "Document #" },
            { field: "parentWarehouse", header: "Division" },
            { field: "warehouse", header: "Warehouse" },
            { field: "partnerName", header: "Partner" },
            { field: "transactionType", header: "Transaction" },
            { field: "direction", header: "Direction" },
            { field: "status", header: "Status" },
            { field: "ackStatus", header: "ACK/API Status" },
        ];
 
        this.headers = new HttpHeaders();
        this.headers = this.headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.search(true);
    }
    search(countFlag=false){
        this.loader=true;
        let reqPayload={
            sortField:this.sortField,
            transactionType:this.group,
            offSet:this.offset,
            limit:this.pageSize,
            countFlag:countFlag,
            sortOrder:this.sortOrder == 1 ? "ASC" : "DESC"
        }
        this.http
            .post(
                environment.apiUrl +"/dashboards/byTransactionGroup",
                reqPayload,
                { headers: this.headers }
            )
            .subscribe((res:any) => {
                this.searchData = res.data;
                if (countFlag) {
                    this.noOfRecords = res.totalRecordsCount;
                }
                this.loader=false;
            });
    }
        //For server side pagination and sorting
    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }
    back() {
        this.location.back();
      }
}
